// Generated T layer lookup table
// Contains flattened taxonomy for Training_Data

export const T_LAYER_LOOKUP = {
  SNG: {
    numericCode: '001',
    name: 'Songs',
  },
  'SNG.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'SNG.TFK': {
    numericCode: '002',
    name: 'Traditional_Folk',
  },
  'SNG.MFK': {
    numericCode: '003',
    name: 'Modern_Folk',
  },
  'SNG.CEL': {
    numericCode: '004',
    name: 'Celtic',
  },
  'SNG.AFR': {
    numericCode: '005',
    name: 'African',
  },
  'SNG.ASN': {
    numericCode: '006',
    name: 'Asian',
  },
  'SNG.LAT': {
    numericCode: '007',
    name: 'Latin_Folk',
  },
  'SNG.MDE': {
    numericCode: '008',
    name: 'Middle_Eastern',
  },
  'SNG.WFU': {
    numericCode: '009',
    name: 'World_Fusion',
  },
  'SNG.AMR': {
    numericCode: '010',
    name: 'Americana',
  },
  'SNG.GLB': {
    numericCode: '011',
    name: 'Global_Folk',
  },
  'SNG.BLU': {
    numericCode: '012',
    name: 'Blues',
  },
  STR: {
    numericCode: '002',
    name: 'Stars',
  },
  'STR.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'STR.PLB': {
    numericCode: '002',
    name: 'Playback',
  },
  'STR.PFU': {
    numericCode: '003',
    name: 'Pop_Fusion',
  },
  'STR.CLS': {
    numericCode: '004',
    name: 'Classical',
  },
  'STR.DNC': {
    numericCode: '005',
    name: 'Dance',
  },
  'STR.IFU': {
    numericCode: '006',
    name: 'Indie_Fusion',
  },
  'STR.ELC': {
    numericCode: '007',
    name: 'Electronic',
  },
  'STR.FLK': {
    numericCode: '008',
    name: 'Folk',
  },
  'STR.SFI': {
    numericCode: '009',
    name: 'Sufi',
  },
  'STR.RMX': {
    numericCode: '010',
    name: 'Remix',
  },
  'STR.GLB': {
    numericCode: '011',
    name: 'Global',
  },
  'STR.PSY': {
    numericCode: '012',
    name: 'Psychedelic',
  },
  'STR.BLU': {
    numericCode: '013',
    name: 'Blues',
  },
  'STR.SOU': {
    numericCode: '014',
    name: 'Soul',
  },
  'STR.PNK': {
    numericCode: '015',
    name: 'Punk',
  },
  'STR.FAN': {
    numericCode: '016',
    name: 'Fantasy',
  },
  LOK: {
    numericCode: '003',
    name: 'Looks',
  },
  'LOK.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'LOK.MED': {
    numericCode: '002',
    name: 'Medieval',
  },
  'LOK.FAI': {
    numericCode: '003',
    name: 'Fairy',
  },
  'LOK.MYT': {
    numericCode: '004',
    name: 'Mythical',
  },
  'LOK.MAG': {
    numericCode: '005',
    name: 'Magical',
  },
  'LOK.ELV': {
    numericCode: '006',
    name: 'Elven',
  },
  'LOK.BLZ': {
    numericCode: '007',
    name: 'Tailored_Blazer',
  },
  'LOK.NEO': {
    numericCode: '008',
    name: 'Neon',
  },
  'LOK.MTL': {
    numericCode: '009',
    name: 'Metallic',
  },
  'LOK.SPO': {
    numericCode: '010',
    name: 'Sportswear',
  },
  MOV: {
    numericCode: '004',
    name: 'Moves',
  },
  'MOV.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'MOV.MED': {
    numericCode: '002',
    name: 'Medieval',
  },
  'MOV.FAI': {
    numericCode: '003',
    name: 'Fairy',
  },
  'MOV.CNT': {
    numericCode: '004',
    name: 'Contemporary',
  },
  'MOV.TRN': {
    numericCode: '005',
    name: 'Trance',
  },
  'MOV.BCH': {
    numericCode: '006',
    name: 'Bachata',
  },
  'MOV.AFB': {
    numericCode: '007',
    name: 'Afrobeats',
  },
  WLD: {
    numericCode: '005',
    name: 'Worlds',
  },
  'WLD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'WLD.CTY': {
    numericCode: '002',
    name: 'City',
  },
  'WLD.STR': {
    numericCode: '003',
    name: 'Street',
  },
  'WLD.SBW': {
    numericCode: '004',
    name: 'Subway',
  },
  'WLD.SKY': {
    numericCode: '005',
    name: 'Skyscraper',
  },
  'WLD.MKT': {
    numericCode: '006',
    name: 'Market',
  },
  'WLD.NAT': {
    numericCode: '007',
    name: 'Nature',
  },
  BRD: {
    numericCode: '006',
    name: 'Branded',
  },
  'BRD.GUC': {
    numericCode: '001',
    name: 'Gucci',
  },
  'BRD.LVU': {
    numericCode: '002',
    name: 'Louis_Vuitton',
  },
  'BRD.NKE': {
    numericCode: '003',
    name: 'Nike',
  },
  PRZ: {
    numericCode: '007',
    name: 'Personalize',
  },
  'PRZ.FAC': {
    numericCode: '001',
    name: 'Face',
  },
  'PRZ.VOI': {
    numericCode: '002',
    name: 'Voice',
  },
  'PRZ.DRS': {
    numericCode: '003',
    name: 'Dress',
  },
};

export const T_SUBCATEGORIES = {
  SNG: [
    'SNG.BAS',
    'SNG.TFK',
    'SNG.MFK',
    'SNG.CEL',
    'SNG.AFR',
    'SNG.ASN',
    'SNG.LAT',
    'SNG.MDE',
    'SNG.WFU',
    'SNG.AMR',
    'SNG.GLB',
    'SNG.BLU',
  ],
  STR: [
    'STR.BAS',
    'STR.PLB',
    'STR.PFU',
    'STR.CLS',
    'STR.DNC',
    'STR.IFU',
    'STR.ELC',
    'STR.FLK',
    'STR.SFI',
    'STR.RMX',
    'STR.GLB',
    'STR.PSY',
    'STR.BLU',
    'STR.SOU',
    'STR.PNK',
    'STR.FAN',
  ],
  LOK: [
    'LOK.BAS',
    'LOK.MED',
    'LOK.FAI',
    'LOK.MYT',
    'LOK.MAG',
    'LOK.ELV',
    'LOK.BLZ',
    'LOK.NEO',
    'LOK.MTL',
    'LOK.SPO',
  ],
  MOV: [
    'MOV.BAS',
    'MOV.MED',
    'MOV.FAI',
    'MOV.CNT',
    'MOV.TRN',
    'MOV.BCH',
    'MOV.AFB',
  ],
  WLD: [
    'WLD.BAS',
    'WLD.CTY',
    'WLD.STR',
    'WLD.SBW',
    'WLD.SKY',
    'WLD.MKT',
    'WLD.NAT',
  ],
  BRD: ['BRD.GUC', 'BRD.LVU', 'BRD.NKE'],
  PRZ: ['PRZ.FAC', 'PRZ.VOI', 'PRZ.DRS'],
};
